const prioritySymbols = ['EURUSD', 'AUDUSD', 'GBPUSD', 'USDCHF', 'USDCAD', 'USDJPY']

export default prioritySymbols
